import * as React from 'react'
import { ContainerSearch } from './styles'
import { IconButton, Stack } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import InputBase from '@mui/material/InputBase'
import { useTranslation } from 'react-i18next'

type Props = {
  onActionSearch: (value: any) => void
}

export const DataGridHeader = ({ onActionSearch }: Props) => {
  const { t } = useTranslation()
  return (
    <Stack
      justifyContent="space-between"
      direction={{ xs: 'column', sm: 'row' }}
      spacing={{ xs: 2, sm: 4, md: 6 }}
      margin={0.5}
    >
      <Stack direction="row">
        <ContainerSearch width={{ xs: '100%', sm: 650 }}>
          <IconButton type="button" sx={{ p: '5px' }} aria-label="search">
            <SearchIcon />
          </IconButton>
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder={`${t('search.titleAthlete')}`}
            onChange={(value) => {
              onActionSearch(value)
            }}
          />
        </ContainerSearch>
      </Stack>
    </Stack>
  )
}
